import Helpers from "../inc/Helpers";
import Ajax from "../inc/Ajax";
import Dropzone from "dropzone";

Dropzone.autoDiscover = false;

class MembersArea {
    constructor() {
        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.contextualMenuSelector =
            "body.portfolio-album .col-items .items .col-contextual-menu";

        this.singleAlbumEditAjaxOverlay = $(
            '.ajax-overlay[data-form-id="single-album-infos"]'
        );

        this.albumID = sarypak.PHPToJS.dashboard.albumID;
        this.albumType = sarypak.PHPToJS.dashboard.albumType;
    }

    init() {
        let self = this;

        self.loginAndSignupForms();
        self.submitDashboardForms();
        self.profilePhoto();
        self.cleanLoginInfosFormOnLoad();
        self.deleteAccount();
        self.createAlbum();
        self.deleteAllAlbums();
        self.deleteSingleAlbum();
        self.updateSingleAlbum();
        self.uploadPhotos();
        self.addVideos();
        self.manageItems();
        self.courseForm();
    }

    loginAndSignupForms() {
        let self = this;

        let step4SkipBtn = $("#photograph-step-4").find(".col-skip a");

        let signupForms = $(`
            form.login, 
            form.user-form:not(.infos form, .profile-photo form, .photograph-career form, .web-profiles form), 
            form.password-reset
        `);

        signupForms.on("submit", function(e) {
            e.preventDefault();

            let thisForm = $(this);
            let ajaxOverlay = thisForm
                .closest("[class^=col-]")
                .find(".ajax-overlay");
            let isLogin = $("body").is(".login");
            let isSignup = $("body").is(".signup");
            let isPasswordReset = $("body").is(".password-reset");
            let isPersonalInfos = $("body").is(".personal-infos");
            let isProfilePhoto =
                thisForm.is("#photograph-step-2") ||
                thisForm.is("#client-step-2");
            let data = thisForm.serializeArray();

            if (parseInt(thisForm.data("no-regular-ajax")) === 1) {
                return;
            }

            const done = function(response) {
                if (isPasswordReset) {
                    thisForm
                        .find(".success")
                        .html(response.message)
                        .show();
                    thisForm.trigger("reset");

                    if (response.status === "passwordChanged") {
                        window.setTimeout(() => {
                            window.location.href = response.redirectUrl;
                        }, 5000);
                    }
                } else if (isLogin || isSignup) {
                    window.location.href = response.redirectUrl;
                } else if (isPersonalInfos && isProfilePhoto) {
                    window.location.reload();
                }
            };

            const fail = function(response) {
                let errors = response.responseJSON.errors;
                let message = response.responseJSON.message;

                self.helpers.formErrors(thisForm, errors);
                ajaxOverlay.hide();
                loadCaptcha(true);

                if (isSignup && message.includes("Invalid address")) {
                    let emailError = thisForm.find(".error-email");

                    emailError
                        .html("Veuillez entrer une adresse email valide")
                        .show();
                }
            };

            const always = function() {
                if (isPasswordReset) {
                    ajaxOverlay.hide();
                }
            };

            data.push({
                name: "window_width",
                value: $(window).width()
            });

            ajaxOverlay.fadeIn(150);
            self.helpers.cleanFormMessages(thisForm);

            self.ajax.post(
                window.location.href,
                "JSON",
                data,
                done,
                fail,
                always
            );
        });

        step4SkipBtn.on("click", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let currentForm = thisBtn.closest("form");

            currentForm.trigger("reset").trigger("submit");
        });
    }

    submitDashboardForms() {
        let self = this;

        let profileMenuToggler = $(".menu-item.profile .toggler span");

        let dashboardForms = $(`
            body.personal-infos .infos form, 
            body.personal-infos .profile-photo form, 
            body.photograph-career .about form, 
            body.photograph-career .web-profiles form,
            body.login-infos form
        `);

        dashboardForms.on("submit", function(e) {
            e.preventDefault();

            let thisForm = $(this);
            let ajaxOverlay = thisForm
                .closest(".form-parent")
                .find(".ajax-overlay");
            let data = thisForm.serializeArray();

            const done = function(response) {
                thisForm
                    .find(".alert-success")
                    .html("Mise à jour effectuée avec succès")
                    .removeClass("d-none");

                if ($("body").is(".personal-infos")) {
                    profileMenuToggler.html(response.firstname);
                }
            };

            const fail = function(response) {
                self.helpers.formErrors(thisForm, response.responseJSON.errors);
            };

            const always = function() {
                ajaxOverlay.fadeOut(150);
            };

            ajaxOverlay.fadeIn(150);
            thisForm.find(".alert-success").addClass("d-none");
            self.helpers.cleanFormMessages(thisForm);

            self.ajax.post(
                window.location.href,
                "JSON",
                data,
                done,
                fail,
                always
            );
        });
    }

    profilePhoto() {
        let mainForm = $("form#photograph-step-2, form#client-step-2");
        let current = mainForm.find(".current img");
        let uploadTriggers = mainForm.find(
            ".current img, .current .no-photo, .controls .upload span"
        );
        let cancelBtn = mainForm.find(".btn.cancel");
        let skipBtn = mainForm.find(".col-skip a");
        let submitBtn = mainForm.find('input[type="submit"]');
        let fileInput = mainForm.find('input[name="profile_photo"]');
        let croppedPhoto = mainForm.find('input[name="cropped_photo"]');

        uploadTriggers.on("click", function() {
            fileInput.trigger("click");
        });

        cancelBtn.on("click", function() {
            cancelBtn.hide();
            current.show();
            uploadTriggers.show();
            croppedPhoto.val("");
            mainForm.find(".croppie-container").remove();
        });

        fileInput.on("change", function(e) {
            e.preventDefault();

            let thisInput = this;

            current.hide();
            uploadTriggers.hide();
            mainForm.find(".croppie-container").remove();
            mainForm
                .find("div.croppie-handler")
                .append('<img class="croppie" />');

            cancelBtn.show();

            if (thisInput.files[0]) {
                let img = $("img.croppie");
                let reader = new FileReader();

                reader.onload = function(e) {
                    img.attr("src", e.target.result)
                        .width(150)
                        .height(200);

                    window.photoCroppie = new Croppie(img[0], {
                        viewport: {
                            width: 200,
                            height: 200,
                            type: "circle"
                        },
                        boundary: {
                            width: 300,
                            height: 300
                        }
                    });
                };

                reader.readAsDataURL(thisInput.files[0]);
            }
        });

        skipBtn.on("click", function(e) {
            e.preventDefault();

            croppedPhoto.val("");
            submitBtn.trigger("click");
        });

        submitBtn.on("click", function() {
            if (typeof window.photoCroppie !== "undefined") {
                window.photoCroppie.result("base64").then(function(dataImg) {
                    croppedPhoto.val(dataImg);
                });
            }

            if ($("body").is(".personal-infos")) {
                $(document).one("ajaxStop", function() {
                    window.location.reload();
                });
            }
        });
    }

    cleanLoginInfosFormOnLoad() {
        let loginInfosForm = $("body.login-infos form");

        loginInfosForm
            .find('[name="email"]')
            .val(sarypak.PHPToJS.userInfos.email);
        loginInfosForm.find('[name="password"]').val("");
    }

    deleteAccount() {
        let self = this;

        let confirmDeleteBtn = $(".btn-confirm-deletion");

        confirmDeleteBtn.on("click", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let ajaxOverlay = thisBtn
                .closest(".form-parent")
                .find(".ajax-overlay");

            const done = function() {
                window.location.href = "/";
            };

            const fail = function() {
                alert(
                    "Erreur lors de la suppression du compte, veuillez réessayer"
                );
            };

            ajaxOverlay.fadeIn(150);

            self.ajax.delete(window.location.href, "JSON", {}, done, fail);
        });
    }

    createAlbum() {
        let self = this;

        let openModalBtn = $(".btn-create-album");
        let modal = $(".modal.create-album");
        let form = modal.find("form");
        let submitBtn = modal.find(".btn.submit");
        let ajaxOverlay = modal.find(".ajax-overlay");

        openModalBtn.on("click", function(e) {
            e.preventDefault();
            modal.modal("show");
        });

        submitBtn.on("click", function(e) {
            e.preventDefault();
            form.trigger("submit");
        });

        form.on("submit", function(e) {
            e.preventDefault();

            let thisForm = $(this);
            let data = thisForm.serializeArray();

            const done = function(response) {
                window.location.href = response.redirectUrl;
            };

            const fail = function(response) {
                ajaxOverlay.fadeOut(150);
                self.helpers.formErrors(thisForm, response.responseJSON.errors);
            };

            data.push({
                name: "action",
                value: "create_album"
            });

            ajaxOverlay.fadeIn(150);
            self.helpers.cleanFormMessages(thisForm);

            self.ajax.post(window.location.href, "JSON", data, done, fail);
        });
    }

    deleteAllAlbums() {
        let self = this;

        let triggerBtn = $("body.portfolio .col-delete .confirm");
        let colAlbums = $("body.portfolio .col-albums");

        triggerBtn.on("click", function(e) {
            e.preventDefault();

            let data = {
                action: "delete_all_albums"
            };

            const done = function() {
                window.location.reload();
            };

            const fail = function() {
                alert("Erreur lors de la suppression, veuillez réessayer.");
                colAlbums.css("opacity", 1);
            };

            colAlbums.css("opacity", 0.3);

            self.ajax.delete(window.location.href, "JSON", data, done, fail);
        });
    }

    deleteSingleAlbum() {
        let self = this;

        let triggerBtn = $(
            ".card-album-dashboard .confirm, .single-album-infos-controls .confirm"
        );
        let fromDetailsView = $("body").hasClass("portfolio-album");

        triggerBtn.on("click", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let card = thisBtn.closest(".card-album-dashboard");
            let colAlbum = thisBtn.closest(".col-album");

            let data = {
                action: "delete_album",
                albumID: card.attr("data-album-id")
            };

            const done = function() {
                if (fromDetailsView) {
                    window.location.href =
                        sarypak.PHPToJS.routes.accountPortfolio;
                } else {
                    colAlbum.fadeOut(150).remove();

                    let remainingAlbums = $(".col-album").length;

                    if (remainingAlbums === 0) {
                        window.location.reload();
                    }
                }
            };

            const fail = function() {
                alert(
                    "Erreur lors de la suppression de l'album, veuillez réessayer."
                );
                self.singleAlbumEditAjaxOverlay.fadeOut(150);
                card.css("opacity", 1);
            };

            self.singleAlbumEditAjaxOverlay.fadeIn(150);
            card.css("opacity", 0.3);

            self.ajax.delete(window.location.href, "JSON", data, done, fail);
        });
    }

    updateSingleAlbum() {
        let self = this;

        let form = $("#single-album-infos");
        let ajaxOverlay = self.singleAlbumEditAjaxOverlay;
        let successMessage = form.find(".alert-success");
        let submitBtn = $(".single-album-infos-controls .update");

        submitBtn.on("click", function(e) {
            e.preventDefault();
            form.trigger("submit");
        });

        form.on("submit", function(e) {
            e.preventDefault();

            let thisForm = $(this);
            let data = thisForm.serializeArray();

            const done = function(response) {
                successMessage
                    .html(response.message)
                    .removeClass("d-none")
                    .fadeIn(150);
            };

            const fail = function(response) {
                self.helpers.formErrors(thisForm, response.responseJSON.errors);
            };

            const always = function() {
                ajaxOverlay.fadeOut(150);
            };

            data.push({
                name: "action",
                value: "update"
            });

            self.helpers.cleanFormMessages(thisForm);
            ajaxOverlay.fadeIn(150);

            self.ajax.put(
                window.location.href,
                "JSON",
                data,
                done,
                fail,
                always
            );
        });
    }

    uploadPhotos() {
        let self = this;

        let modalTriggerBtn = $(".trigger-upload-photos-modal");
        let modal = $(".modal.upload-photos");
        let ajaxOverlay = modal.find(".ajax-overlay");
        let uploadZone = $(".photos-upload-zone");
        let uploadRealInput = modal.find("#photos-upload-input");
        let thumbnailsWrapper = modal.find(".thumbnails");
        let errorsWrapper = uploadZone.find(".error-messages");
        let singleSizeLimitWrapper = errorsWrapper.find(".single-size-limit");
        let totalSizesErrorWrapper = errorsWrapper.find(".total-limit");
        let submitBtn = modal.find("a.submit");
        let singleSizeLimit = 1024 * 1024 * 1;
        let totalPhotosSizeLimit = 1024 * 1024 * 8;
        let totalPhotosSize = 0;
        let filteredPhotos = {};

        if (uploadZone.length === 0) {
            return;
        }

        modalTriggerBtn.on("click", function(e) {
            e.preventDefault();
            modal.modal("show");
        });

        uploadZone.on("click", function() {
            uploadRealInput.trigger("click");
        });

        uploadRealInput.on("change", function() {
            let thisInput = $(this);
            let photos = thisInput[0].files;
            let showSingleSizeLimitError = false;

            singleSizeLimitWrapper.fadeOut(150);

            if (photos) {
                photos.forEach(function(photo) {
                    let fileReader = new FileReader();
                    let photoSize = photo.size;

                    totalPhotosSize += photoSize;

                    if (totalPhotosSize > totalPhotosSizeLimit) {
                        totalPhotosSize -= photoSize;
                        totalSizesErrorWrapper.fadeIn(150);
                        return;
                    }

                    if (photoSize <= singleSizeLimit) {
                        let date = new Date();
                        let photoID =
                            String(date.getTime()) +
                            "_" +
                            String(Math.floor(Math.random() * 10000));

                        fileReader.onload = function(e) {
                            let base64Img = e.target.result;

                            let thumbnailHtml =
                                `
                                <div class="col-md-4 col-thumbnail" 
                                     data-photo-id="` +
                                photoID +
                                `" 
                                     data-photo-size="` +
                                photoSize +
                                `"
                                >
                                    <button class="close">
                                        <i class="fa fa-circle"></i>
                                        <span>&times;</span>
                                    </button>
    
                                    <img src="` +
                                base64Img +
                                `" />
                                </div>
                            `;

                            thumbnailsWrapper.append(thumbnailHtml);

                            filteredPhotos[photoID] = photo;
                        };

                        fileReader.readAsDataURL(photo);
                        submitBtn.show();
                    } else {
                        totalPhotosSize -= photoSize;
                        showSingleSizeLimitError = true;
                    }
                });

                if (showSingleSizeLimitError) {
                    singleSizeLimitWrapper.fadeIn(150);
                }
            }
        });

        $("body").on(
            "click",
            "#modal-upload-photos .col-thumbnail .close",
            function() {
                let thisBtn = $(this);
                let thisThumbnail = thisBtn.closest(".col-thumbnail");
                let photoID = thisThumbnail.attr("data-photo-id");
                let photoSize = parseInt(thisThumbnail.attr("data-photo-size"));

                delete filteredPhotos[photoID];

                thisThumbnail.fadeOut(150);

                totalPhotosSize -= photoSize;

                if (totalPhotosSize < totalPhotosSizeLimit) {
                    totalSizesErrorWrapper.fadeOut(150);
                }

                if (Object.keys(filteredPhotos).length === 0) {
                    submitBtn.hide();
                }
            }
        );

        submitBtn.on("click", function(e) {
            e.preventDefault();

            let formData = new FormData();

            const done = function() {};

            const fail = function(response) {
                let errorMessage = response.responseJSON.message
                    ? response.responseJSON.message
                    : "Une erreur inattendue s'est produite";
                errorMessage += ". La page va se recharger.";

                alert(errorMessage);
            };

            const always = function() {
                window.location.reload();
            };

            formData.append("action", "upload_photos");
            formData.append("albumID", self.albumID);

            for (let [photoID, filteredPhoto] of Object.entries(
                filteredPhotos
            )) {
                formData.append(photoID, filteredPhoto, filteredPhoto.name);
            }

            ajaxOverlay.fadeIn(150);

            self.ajax.postWithFiles(
                window.location.href,
                "JSON",
                formData,
                done,
                fail,
                always
            );
        });
    }

    addVideos() {
        let self = this;

        let modalTriggerBtn = $(".trigger-add-videos-modal");
        let modal = $(".modal.add-videos");
        let ajaxOverlay = modal.find(".ajax-overlay");
        let submitBtn = modal.find(".submit");
        let videoInputsWrapper = modal.find(".video-inputs");
        let videoInput = `
            <div class="video-link">
                <input type="text" class="form-control" name="video_links[]" placeholder="Lien Youtube de la vidéo" />
                <span class="remove-video-line">&times;</span>
            </div>
        `;

        modalTriggerBtn.on("click", function(e) {
            e.preventDefault();
            modal.modal("show");
            videoInputsWrapper.html(videoInput);
        });

        $("body").on("click", ".add-video-line", function(e) {
            e.preventDefault();
            videoInputsWrapper.append(videoInput);
        });

        $("body").on("click", ".remove-video-line", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let videoLine = thisBtn.closest(".video-link");

            videoLine.fadeOut(150).remove();
        });

        submitBtn.on("click", function(e) {
            e.preventDefault();

            let form = $(".video-inputs");
            let data = form.serializeArray();

            const done = function() {
                window.location.reload();
            };

            const fail = function() {
                alert("Erreur lors de la requête, veuillez réessayer.");
                ajaxOverlay.fadeOut(150);
            };

            data.push({
                name: "action",
                value: "add_videos"
            });

            ajaxOverlay.fadeIn(150);

            self.ajax.post(window.location.href, "JSON", data, done, fail);
        });
    }

    manageItems() {
        let self = this;

        let items = self.getAllItems();
        let itemLightboxSelector = "body.portfolio-album .item-lightbox";
        let itemLightbox = $(itemLightboxSelector);

        items.on("click", function() {
            let thisItem = $(this);

            self.markItemAs("selected", thisItem);
            self.showItemContextualMenu(thisItem);
        });

        items.on("dblclick", function() {
            let thisItem = $(this);

            switch (self.albumType) {
                case "Photo":
                    let photoLightbox = $(itemLightboxSelector + ".photo");
                    let photoLightboxImg = photoLightbox.find("img");
                    let photoSrc = thisItem.attr("src");

                    photoLightbox.fadeIn(75);
                    photoLightboxImg.attr("src", photoSrc);
                    break;

                case "Vidéo":
                    let videoLightbox = $(itemLightboxSelector + ".video");
                    let embedWrapper = videoLightbox.find(".embed-responsive");
                    let videoID = thisItem.attr("data-video-id");
                    let iframe =
                        `
                        <iframe class="embed-responsive-item" 
                                src="https://www.youtube.com/embed/` +
                        videoID +
                        `?rel=0"
                        ></iframe>
                    `;

                    videoLightbox.fadeIn(75);
                    embedWrapper.empty().append(iframe);
                    break;

                default:
                    return;
            }
        });

        itemLightbox.on("click", function(e) {
            if (!self.helpers.inArray(e.target.nodeName, ["IMG", "IFRAME"])) {
                itemLightbox.fadeOut(75);
            }
        });

        $(document).on("keydown", function(e) {
            if (e.key === "Escape") {
                itemLightbox.fadeOut(75);
            }
        });
    }

    showItemContextualMenu(item) {
        let self = this;

        let contextualMenu = $(self.contextualMenuSelector);
        let closeBtn = contextualMenu.find(".close");
        let top =
            item.offset().top -
            item.closest(".items").offset().top +
            item.height() +
            10;

        self.populateContextualMenu(contextualMenu, item);

        switch (self.albumType) {
            case "Photo":
                let photoFilename = item.attr("data-photo-filename");
                contextualMenu.attr("data-photo-filename", photoFilename);
                break;

            case "Vidéo":
                let videoLink = item.attr("data-video-link");
                contextualMenu.attr("data-video-link", videoLink);
                break;

            default:
                return;
        }

        contextualMenu.fadeIn(150).css("top", top);

        contextualMenu.find(".delete").show();

        contextualMenu.find(".confirm, .cancel").hide();

        closeBtn.on("click", function() {
            contextualMenu.fadeOut(150);
        });
    }

    populateContextualMenu(contextualMenu, item) {
        let self = this;

        let options = "";
        let coverText = !item.is(".cover")
            ? "Définir comme couverture de l'album"
            : "Ne plus définir comme couverture de l'album";
        let featuredText = !item.is(".featured")
            ? "Mettre en avant sur le profil"
            : "Ne plus mettre en avant sur le profil";

        options += '<a href="#" class="confirm">Confirmer</a>';
        options += '<a href="#" class="cancel">Annuler</a>';
        options +=
            '<a href="#" class="delete">Supprimer la ' +
            self.albumType.toLowerCase() +
            "</a>";
        options +=
            '<a href="#" class="define-as-album-cover">' + coverText + "</a>";

        if (sarypak.PHPToJS.userInfos.isPro && self.albumType === "Photo") {
            options +=
                '<a href="#" class="define-as-featured">' +
                featuredText +
                "</a>";
        }

        contextualMenu.find(".wrapper").html(options);

        self.itemContextualMenuActions(contextualMenu, item);
    }

    itemContextualMenuActions(contextualMenu, item) {
        let self = this;

        let ajaxOverlay = contextualMenu
            .closest(".items")
            .find(".ajax-overlay");
        let deleteBtn = contextualMenu.find(".confirm");
        let defineAsCoverBtn = contextualMenu.find(".define-as-album-cover");
        let defineAsFeaturedBtn = contextualMenu.find(".define-as-featured");

        deleteBtn.on("click", function(e) {
            e.preventDefault();
            self.deleteItem(contextualMenu, item, ajaxOverlay);
        });

        defineAsCoverBtn.on("click", function(e) {
            e.preventDefault();
            self.defineItemAs("cover", contextualMenu, item, ajaxOverlay);
        });

        defineAsFeaturedBtn.on("click", function(e) {
            e.preventDefault();
            self.defineItemAs("featured", contextualMenu, item, ajaxOverlay);
        });
    }

    deleteItem(contextualMenu, item, ajaxOverlay) {
        let self = this;

        let data = {
            action: "delete_item"
        };

        const done = function() {
            item.parent()
                .fadeOut(150)
                .remove();

            contextualMenu.fadeOut(150);

            let remainingItems = $(".items .col-item").length;

            if (remainingItems === 0) {
                window.location.reload();
            }
        };

        const fail = function() {
            alert("Erreur lors de la suppression, veuillez réessayer.");
        };

        const always = function() {
            ajaxOverlay.fadeOut(150);
        };

        data = self.addAjaxDataItem(data, item);

        ajaxOverlay.fadeIn(150);

        self.ajax.delete(
            window.location.href,
            "JSON",
            data,
            done,
            fail,
            always
        );
    }

    defineItemAs(context, contextualMenu, item, ajaxOverlay) {
        let self = this;

        let action = !item.is("." + context)
            ? "define_item_as_" + context
            : "undefine_item_as_" + context;

        let data = {
            action: action
        };

        const done = function() {
            contextualMenu.fadeOut(150);

            if (action.indexOf("undefine_item_as_")) {
                self.markItemAs(context, item);
            } else {
                self.markItemAs(context, item, false);
            }
        };

        const fail = function() {
            alert(
                "Erreur lors du traitement de la requête, veuillez réessayer."
            );
        };

        const always = function() {
            ajaxOverlay.fadeOut(150);
        };

        data = self.addAjaxDataItem(data, item);

        ajaxOverlay.fadeIn(150);

        self.ajax.post(window.location.href, "JSON", data, done, fail, always);
    }

    getAllItems() {
        return $("body.portfolio-album .col-items .items .col-item img");
    }

    getPhotoFilename(photo) {
        return photo.attr("data-photo-filename");
    }

    getVideoLink(photo) {
        return photo.attr("data-video-link");
    }

    addAjaxDataItem(data, item) {
        let self = this;

        switch (self.albumType) {
            case "Photo":
                data.photoFilename = self.getPhotoFilename(item);
                break;

            case "Vidéo":
                data.videoLink = self.getVideoLink(item);
                break;
        }

        return data;
    }

    markItemAs(elementClass, theItem, markOne = true) {
        let self = this;

        if (self.helpers.inArray(elementClass, ["selected", "cover"])) {
            let items = self.getAllItems();

            items.each(function() {
                let thisLoopedItem = $(this);
                thisLoopedItem.removeClass(elementClass);
            });

            if (markOne) {
                theItem.addClass(elementClass);
            }
        } else if (elementClass === "featured") {
            theItem.toggleClass("featured");
        }
    }

    courseForm() {
        let self = this;

        let form = $(".course-form form");
        let imageInput = form.find('#image[type="file"]');
        let alertSuccess = form.find(".alert-success");
        let submitBtn = $(".course-form .btn.submit");
        let isCreateForm =
            parseInt(submitBtn.attr("data-is-create-form")) === 1;
        let overlay = $(".course-form .ajax-overlay");
        let imageErrorWrapper = form.find(".error.error-image");

        imageInput.on("change", function() {
            let thisInput = $(this);
            let file = thisInput[0].files[0];
            let img = new Image();
            let imageName = thisInput.siblings(".image-name");
            let authorizedMimeTypes = ["image/jpg", "image/jpeg", "image/png"];
            let valid = true;

            imageName.empty();

            img.src = window.URL.createObjectURL(file);

            img.onload = function() {
                let fileResolution = {
                    width: this.naturalWidth,
                    height: this.naturalHeight
                };

                if (
                    fileResolution.width < 1200 ||
                    fileResolution.height < 600
                ) {
                    imageErrorWrapper.html(
                        "La résolution du fichier doit être au minimum 1200px x 600px"
                    );
                    valid = false;
                } else if (
                    self.helpers.inArray(file.type, authorizedMimeTypes)
                ) {
                    imageName.html(file.name);
                }

                if (!valid) {
                    thisInput.val("");
                } else {
                    imageErrorWrapper.empty();
                }
            };
        });

        submitBtn.on("click", function(e) {
            e.preventDefault();
            form.trigger("submit");
        });

        form.on("submit", function(e) {
            e.preventDefault();

            let thisForm = $(this);
            let formData = new FormData(thisForm[0]);

            const done = function(response) {
                if (isCreateForm) {
                    window.location.href = response.redirectUrl;
                } else {
                    self.ajax.hideLoader(overlay);
                    alertSuccess
                        .html("Mise à jour effectuée avec succès")
                        .show();
                }
            };

            const fail = function(response) {
                self.helpers.formErrors(thisForm, response.responseJSON.errors);
                self.ajax.hideLoader(overlay);

                if (response.error === "image_not_uploaded") {
                    alert(
                        "Erreur lors de l'upload de l'image, veuillez réessayer."
                    );
                }
            };

            formData.append(
                "file",
                thisForm.find('[name="image"]')[0].files[0]
            );

            thisForm.find(".success").hide();

            thisForm.find(".error").empty();

            self.ajax.showLoader(overlay);

            self.ajax.postWithFiles(
                window.location.href,
                "JSON",
                formData,
                done,
                fail
            );
        });
    }
}

export default MembersArea;
